import { createStoreWithPersistent } from "@core/hooks/useStore";
import { StateCreator } from "zustand";

interface IStore {
  stationDevice?: string;
  avatarDevice?: string;
  setStationDevice?: (stationDevice: string) => void;
  setAvatarDevice?: (avatarDevice: string) => void;
}

const store: StateCreator<IStore> = (set) => ({
  stationDevice: "",
  avatarDevice: "",
  setStationDevice: (stationDevice) => set(() => ({ stationDevice })),
  setAvatarDevice: (avatarDevice) => set(() => ({ avatarDevice })),
});

export const useStoreDevice = createStoreWithPersistent<IStore>({
  initialState: store,
  nameStorage: "device",
  storage: "local",
});
